import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedText, formatText } from 'core/i18n';
import { LOAN } from 'constants/userProfile';
import { PUBLICA_URL } from 'constants';
import preLoaderActions from 'actions/preLoaderActions';
import { Header } from 'components/header/header';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import { useRedirectToHome } from 'routes/messagesView/ErrorsView/hooks/useRedirectToHome';
import { useRecordPageError } from 'routes/messagesView/ErrorsView/hooks/useRecordPageError';
import { useDeleteCookies } from 'routes/messagesView/ErrorsView/hooks/useDeleteCookies';

const ErrorsView = ({
    userProfile,
    errorState,
    preLoaderActions,
    title,
    subtitle,
    content,
    iconClass,
    action,
    buttonText,
    buttonClass,
    injectedContent,
}) => {
    const defaultContent = userProfile.investmentType === LOAN ? 'messagesScreen-defaultErrorContent_ares' : content;

    useRedirectToHome(userProfile);
    useDeleteCookies(preLoaderActions);
    useRecordPageError({ errorState, defaultContent, userProfile });

    const buttonAction = () => {
        if (userProfile.dossierFailStatusCode && userProfile.dossierFailStatusCode.toString() === '401') {
            window.location.href = `${PUBLICA_URL}prestamo-ares`;

            return;
        }
        action();
    };

    const injectedContentValue = userProfile.injectedContentValue || injectedContent;

    return (
        <div>
            <Header titleClass="hidden" />
            <div className="main-container messages-main-container basic-layering">
                <MessagesScreen
                    iconClass={
                        typeof userProfile.errorIconClass !== 'undefined' ? userProfile.errorIconClass : iconClass
                    }
                    title={typeof userProfile.errorTitle !== 'undefined' ? userProfile.errorTitle : title}
                    subtitle={typeof userProfile.errorSubtitle !== 'undefined' ? userProfile.errorSubtitle : subtitle}
                    buttonText={typeof userProfile.buttonText !== 'undefined' ? userProfile.buttonText : buttonText}
                    buttonClass={typeof userProfile.buttonClass !== 'undefined' ? userProfile.buttonClass : buttonClass}
                    action={buttonAction}
                >
                    <FormattedText
                        value={errorState.errorContent ?? defaultContent}
                        injectedStrings={injectedContentValue}
                    />
                </MessagesScreen>
            </div>
        </div>
    );
};

ErrorsView.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string,
    iconClass: PropTypes.string,
    action: PropTypes.func,
    buttonText: PropTypes.string,
    buttonClass: PropTypes.string,
    injectedContent: PropTypes.array,
    userProfile: PropTypes.object,
    errorState: PropTypes.object,
    preLoaderActions: PropTypes.object,
};

ErrorsView.defaultProps = {
    title: formatText('messagesScreen-defaultErrorTitle'),
    subtitle: '',
    content: 'messagesScreen-defaultErrorContent',
    iconClass: 'icons icons--icon-warning',
    action: () => {
        window.location.href = PUBLICA_URL;
    },
    buttonText: formatText('button-understood'),
    buttonClass: 'form__button form__button-primary',
    injectedContent: [],
};

export default connect(
    state => ({
        userProfile: state.userProfile,
        errorState: state.error,
    }),
    dispatch => ({
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(ErrorsView);
